// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__89nth","vLegacy":"SelectSecondary_vLegacy__3T3z9","error":"SelectSecondary_error__3z8zN","disabled":"SelectSecondary_disabled__2dfIx"};